import React, { useState } from 'react';
import './Pricing.css';


const Pricing = () => {
  // State for active tab
  const [activeTab, setActiveTab] = useState('Bulk Data');

  // Handle tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  // Updated pricing data for different tabs
  const pricingData = {
    'Bulk Data': {
      type: 'cards',
      packages: [
        {
          icon: '/images/starter.svg',
          title: 'Trial Package',
          description: 'Run your first test reward for free',
          price: 'Free',
          rate: '10 free units of 20 MB',
          features: [
            '10 free SMS',
          ],
        },
        {
          icon: '/images/growth.svg',
          title: 'Starter Package',
          description: 'For growing businesses looking to increase customer loyalty',
          price: 'Ksh 10,000',
          rate: 'Rate per MB: KES 0.20',
          features: [
            'Disburse Data via Self Service Platform or via API',
            '500 free SMS',
          ],
          popular: true,
        },
        {
          icon: '/images/pro.svg',
          title: 'Growth Package',
          description: 'For large businesses looking for tailor-made use cases',
          price: 'Ksh 250,000',
          rate: 'Custom',
          features: [
            'Disburse Data via Self Service Platform or via API',
            '2,000 free SMS',
          ],
        },
      ],
    },
    'Bulk SMS': {
      type: 'sms_pricing',
      data: [
        { planTier: 'Basic',    quantity: '25,000 - 125,000 Units', rate: '1.06 Ksh per SMS' },
        { planTier: 'Plus',     quantity: '125,001 - 524,999 Units', rate: '0.85 Ksh per SMS' },
        { planTier: 'Premium',  quantity: '525,000 +',              rate: 'Custom' },
      ],
    },
    'Bulk Airtime': {
      type: 'discount_table',
      data: [
        { planTier: 'Basic Plan',   range: '0 – 19,999',            discountRate: '3%' },
        { planTier: 'Plus Plan',    range: '20,000 – 99,999',        discountRate: '3%' },
        { planTier: 'Premium Plan', range: '100,000 – 399,999',      discountRate: '4%' },
        { planTier: 'Max Plan',     range: '400,000 and above',       discountRate: '5%' },
      ],
    },

    'Sender ID': {
      type: 'sender_table',
      data: {
        label: 'Sender ID Fee',
        amount: 'KES 6500',
      },
    },
    'Short Code': {
      type: 'shortcode_table',
      data: [
        { label: 'Set Up Fee',   
          shared: 'KES 5,000',
          dedicated: 'KES 15,000',
          golden:'KES 200,000'
        },
        { label: 'Monthly Fee',  
          shared: 'KES 2,000',
          dedicated:'KES 15,000',
          golden:'KES 20,000'
        },
      ],
    },
    'USSD': {
      type: 'ussd_table',
      data: [
        {
          label: 'Set Up Fee',
          shared:   'KES 15,000',
          dedicated:'KES 250,000',
        },
        {
          label: 'Monthly Fee',
          shared:   'KES 5,000',
          dedicated:'KES 50,000',
        },
      ],
    },
  };

  // Renders the “cards” layout for Bulk Data
  const renderCards = (packages) => (
    <div className="pricing-cards-container">
      {packages.map((pkg, index) => (
        <div key={index} className={`pricing-card ${pkg.popular ? 'popular' : ''}`}>
          {pkg.popular && <div className="popular-tag">Popular</div>}
          <div className="package-icon">
            <img src={pkg.icon} alt={pkg.title} />
          </div>
          <h3 className="package-title">{pkg.title}</h3>
          <p className="package-description">{pkg.description}</p>
          <div className="package-price">
            <h2>{pkg.price}</h2>
          </div>
          <p className="package-rate">{pkg.rate}</p>
          <div className="package-features">
            {pkg.features.map((feature, fIndex) => (
              <p key={fIndex}>{feature}</p>
            ))}
          </div>

        </div>
      ))}
    </div>
  );

  // Renders the “discount table” for Bulk Airtime
  const renderDiscountTable = (data) => (
    <div className="pricing-table-container">
      <div className="pricing-table">
        <div className="table-header">
          <div className="header-cell">Plan Tier</div>
          <div className="header-cell">Range</div>
          <div className="header-cell">Discount Rate</div>
        </div>
        {data.map((row, index) => (
          <div key={index} className="table-row">
            <div className="table-cell" data-label="Plan Tier">{row.planTier}</div>
            <div className="table-cell" data-label="Range">{row.range}</div>
            <div className="table-cell" data-label="Discount Rate">{row.discountRate}</div>

          </div>
        ))}
      </div>
    </div>
  );

  // Renders the “SMS pricing table” for Bulk SMS
  const renderSMSPricing = (data) => (
    <div className="pricing-table-container">
      <div className="pricing-table">
        <div className="table-header">
          <div className="header-cell">Plan Tier</div>
          <div className="header-cell">Quantity</div>
          <div className="header-cell">Rate</div>
        </div>
        {data.map((row, index) => (
          <div key={index} className="table-row">
            <div className="table-cell" data-label="Plan Tier">{row.planTier}</div>
            <div className="table-cell" data-label="Quantity">{row.quantity}</div>
            <div className="table-cell" data-label="Rate">{row.rate}</div>
          </div>
        ))}
      </div>
    </div>
  );

  // Renders the single‐row “Sender ID” table
  const renderSenderIDTable = (data) => (
    <div className="pricing-table-container simple-table">
      <div className="pricing-table">
        <div className="table-header">
          <div className="header-cell">Description</div>
          <div className="header-cell">Amount</div>
        </div>
        <div className="table-row">
          <div className="table-cell" data-label="Description">{data.label}</div>
          <div className="table-cell" data-label="Amount">{data.amount}</div>
        </div>
      </div>
    </div>
  );

  // Renders the two‐row “Short Code” table
  const renderShortCodeTable = (data) => (
    <div className="pricing-table-container simple-table">
      <div className="pricing-table">
        <div className="table-header">
        <div className="header-cell"></div>
          <div className="header-cell">Shared</div>
          <div className="header-cell">Dedicated</div>
          <div className="header-cell">Golden</div>

        </div>
        {data.map((row, index) => (
          <div key={index} className="table-row">
            <div className="table-cell" data-label="Description">{row.label}</div>
            <div className="table-cell" data-label="Shared">{row.shared}</div>
            <div className="table-cell" data-label="Dedicated">{row.dedicated}</div> 
            <div className="table-cell" data-label="Golden">{row.golden}</div> 

         </div>
        ))}
      </div>
    </div>
  );

  // Renders the two‐row, three‐column “USSD” table
  const renderUssdTable = (data) => (
    <div className="pricing-table-container ussd-table">
      <div className="pricing-table">
        <div className="table-header">
          <div className="header-cell"></div>
          <div className="header-cell">Shared</div>
          <div className="header-cell">Dedicated</div>
        </div>
        {data.map((row, index) => (
          <div key={index} className="table-row">
            <div className="table-cell" data-label="">{row.label}</div>
            <div className="table-cell" data-label="Shared">{row.shared}</div>
            <div className="table-cell" data-label="Dedicated">{row.dedicated}</div>
          </div>
        ))}
      </div>
    </div>
  );

  const currentPricing = pricingData[activeTab];

  return (
    <div className="pricing-page">
      {/* Hero Section */}
      <section className="pricing-hero">
        <div className="hero-content">
          <h1>Plans &amp; Pricing</h1>
          <p className="mission">Explore our pricing options and choose the plan that best fits your needs.</p>

          <a
                href="https://app.peakmobile.co.ke/signin" 
                target="_blank"
                rel="noopener noreferrer">
                <button className="contact-sales-button">Start Free Trial</button>

              </a>
        </div>
        <div className="hero-background">
          <div className="circle-navy"></div>
          <div className="circle-light-blue"></div>
          <div className="circle-peach"></div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing-section">
        <div className="pricing-tabs">
          {[
            'Bulk Data',
            'Bulk SMS',
            'Bulk Airtime',
            'Sender ID',
            'Short Code',
            'USSD',
          ].map((tabName) => (
            <button
              key={tabName}
              className={`tab-button-price ${activeTab === tabName ? 'active' : ''}`}
              onClick={() => handleTabChange(tabName)}
            >
              {tabName}
            </button>
          ))}
        </div>

        {/* Dynamic Content Rendering */}
        {currentPricing.type === 'cards' && renderCards(currentPricing.packages)}
        {currentPricing.type === 'discount_table' && renderDiscountTable(currentPricing.data)}
        {currentPricing.type === 'sms_pricing' && renderSMSPricing(currentPricing.data)}
        {currentPricing.type === 'sender_table' && renderSenderIDTable(currentPricing.data)}
        {currentPricing.type === 'shortcode_table' && renderShortCodeTable(currentPricing.data)}
        {currentPricing.type === 'ussd_table' && renderUssdTable(currentPricing.data)}
      </section>
    </div>
  );
};

export default Pricing;
